import { useState } from 'react';
import api from '../functions/api';

/**
 * Hook for contextual help functionality
 * @param {string} screenId - Screen identifier (e.g., 'trendsearch.tickerAggregates')
 * @returns {object} - { openHelp, helpOpen, helpData, helpLoading, helpError, closeHelp }
 */
export function useContextualHelp(screenId) {
  const [helpOpen, setHelpOpen] = useState(false);
  const [helpLoading, setHelpLoading] = useState(false);
  const [helpError, setHelpError] = useState(null);
  const [helpData, setHelpData] = useState(null);

  const openHelp = async (fieldId, label, selection = {}) => {
    try {
      setHelpError(null);
      setHelpLoading(true);
      setHelpOpen(true);
      const payload = {
        screenId,
        fieldId,
        label,
        selection
      };
      const resp = await api.post('/contextual_help', payload);
      setHelpData(resp?.data || {});
    } catch (e) {
      setHelpError(e?.message || 'Failed to load help');
    } finally {
      setHelpLoading(false);
    }
  };

  const closeHelp = () => {
    setHelpOpen(false);
  };

  return {
    openHelp,
    helpOpen,
    helpData,
    helpLoading,
    helpError,
    closeHelp
  };
}

